import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of, forkJoin, empty } from 'rxjs';
import { catchError} from 'rxjs/operators';
import { StorageManagerService, LLFormService, CompanyContactService } from '../../shared/services/index';
import { ERFormService } from '../services/er-form-service';

@Injectable()
export class ERFormResolverService implements Resolve<any> {
    revisionId: string;
    customerGuid: string;

  constructor (private erService: ERFormService, private storageManagerService: StorageManagerService,
      private llservice: LLFormService, private companyService: CompanyContactService, private contactService: CompanyContactService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {

    const revisionId = route.params.revisionId;
    const currentCustomerStr: string = this.storageManagerService.read('currentCustomer');

    if (currentCustomerStr) {
        const currentCustomer = typeof currentCustomerStr === 'object' ? currentCustomerStr : JSON.parse(currentCustomerStr);
        if (currentCustomer) {
        this.customerGuid = currentCustomer.customerGuid;
        }
    }

    const retVal = forkJoin([
            revisionId ? this.erService.getERFormById(revisionId) : of(null),
            this.llservice.getSSDPVocabularies(),
            this.llservice.getLCompanyTypesByCustomerGuid(this.customerGuid),
            this.companyService.getBusinessCategories(false),
            revisionId ? this.erService.getRevisionHistory(revisionId) : of(null),
            this.contactService.getCountries(),
            this.companyService.getContacts()]
        )
        .pipe(catchError(err => of({ error: err })));

        return retVal;
    }
}
